<template>
    <span class="block overflow-hidden text-ellipsis">{{ displayValue }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
    value?: number | string | null;
}>();

const displayValue = computed(() => {
    if (props.value === null || props.value === undefined) {
        return '0'; // discuss, should it be 0 or '' or 'N/A'
    }
    return String(props.value);
});
</script>
